<div class="ir-item-line th-filter">
  <div class="ir-item-cell s5 clickable">
    <span>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div class="ir-item-cell s5 clickable">
    <span>
      {{ 'customers.crm-id' | translate }}
    </span>
  </div>
</div>
<div class="ir-content-flow has-filter has-actions" (scroll)="scroll($event)">
  <div class="ir-section--list">
    <div class="ir-item-line th-inspection clickable" (click)="selectCustomer(customer)" *ngFor="let customer of customers">
      <div class="ir-item-cell s5">
        <span>{{ customer.name }}</span>
      </div>
      <div class="ir-item-cell s5">
        <span>{{ customer.clientNumber }}</span>
      </div>
    </div>
    <div class="ir-item-empty ir-mv8" *ngIf="!customers?.length">
      <p>
        <span>{{ 'customers.no-customers' | translate }}</span>
      </p>
    </div>
  </div>
</div>
